import React, { Component, ReactComponentElement } from 'react';
import { Cell, Pie, PieChart } from 'recharts';

import UtilsService from '../../../services/utils.service';

export default class BwPieChart extends Component<any> {
    public hexColors: string[];

    public override render(): ReactComponentElement<any> {
        const nameList: string[] = this.props.data.map((element: { [x: string]: any }) => {
            return element.name;
        });
        this.hexColors = UtilsService.getColorListForStringList(nameList);

        const view: JSX.Element = (
            <div className={`pie-container ${this.props.className}`}>
                <PieChart className="expenses-pie" width={this.props.width} height={this.props.width}>
                    <Pie
                        data={this.props.data}
                        dataKey="value"
                        cx={0.48 * this.props.width}
                        cy={0.48 * this.props.width}
                        innerRadius={0.3 * this.props.width}
                        outerRadius={0.48 * this.props.width}
                        fill="#8884d8"
                        paddingAngle={0}
                    >
                        {this.props.data.map((entry: any, index: number) => (
                            <Cell key={index} fill={this.hexColors[index % this.hexColors.length]} />
                        ))}
                    </Pie>
                </PieChart>
            </div>
        );

        return view;
    }
}
